module.exports = __webpack_public_path__ + "img/defaultHead.ae2942bb.png";